import React from "react";
import LabShell from "@/components/LabShell";

const H2 = ({ children }) => (
  <h2 className="text-xl sm:text-2xl mt-10 mb-3" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}>
    {children}
  </h2>
);
const P = ({ children }) => (
  <p className="text-sm sm:text-base max-w-[70ch] mb-3" style={{ color: "#5C5268", lineHeight: 1.8 }}>
    {children}
  </p>
);

const PRIVACY = (
  <>
    <H2>What we collect</H2>
    <P>
      You can play with everything in the Jewish Music Lab without telling us anything. If you
      ask to be notified about new experiments, we keep the first name and email address you
      give us, and nothing else.
    </P>
    <H2>What we do with it</H2>
    <P>
      We use it for one thing: to email you when a new experiment opens. It's stored with our
      email provider (Systeme.io) and tagged so we know you came from the lab. We don't sell
      it, rent it, or hand it to advertisers.
    </P>
    <H2>Payments</H2>
    <P>
      Contributions are processed by Stripe. Card details never touch our servers — we only
      keep a record that a contribution happened, so we can answer you if something goes wrong.
    </P>
    <H2>Getting out</H2>
    <P>
      Every email has an unsubscribe link, and you can write to us any time to have your
      details deleted outright.
    </P>
  </>
);

const TERMS = (
  <>
    <H2>Use of the lab</H2>
    <P>
      The experiments here are free to play with, including in classrooms, camps and shuls.
      Record them, perform with them, teach with them — that's what they're for.
    </P>
    <H2>What's not included</H2>
    <P>
      The lab is offered as-is. Experiments may change, break or disappear while we work on
      them, and audio behaviour depends on your browser and device.
    </P>
    <H2>Contributions</H2>
    <P>
      Contributions support ongoing development. They are not tax-deductible donations and do
      not purchase a product or a guarantee of future features. Monthly contributions can be
      cancelled at any time through the receipt Stripe emails you.
    </P>
    <H2>The music you make</H2>
    <P>
      Whatever you create with these tools is yours. The tools themselves, the letter-to-note
      mappings and the code behind them remain the work of Dan Berry.
    </P>
  </>
);

export default function LabLegal({ kind }) {
  const isPrivacy = kind === "privacy";
  return (
    <LabShell>
      <article className="pt-14 sm:pt-20 pb-20">
        <p
          className="text-xs uppercase mb-4"
          style={{ color: "#8C8198", fontFamily: "'Courier Prime', monospace", letterSpacing: "0.22em" }}
        >
          Jewish Music Lab
        </p>
        <h1
          className="text-4xl sm:text-5xl"
          style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}
          data-testid={`legal-title-${kind}`}
        >
          {isPrivacy ? "Privacy" : "Terms"}
        </h1>
        {isPrivacy ? PRIVACY : TERMS}
        <p className="mt-10 text-xs" style={{ color: "#8C8198" }}>
          Questions? Reach us through{" "}
          <a
            href="https://danberrymusic.com"
            target="_blank"
            rel="noreferrer"
            className="underline underline-offset-2"
          >
            danberrymusic.com
          </a>
          .
        </p>
      </article>
    </LabShell>
  );
}
